module.exports = __webpack_public_path__ + "static/media/191IT234.0aed196f.jpeg";